import { render, staticRenderFns } from "./addNewNumbers.vue?vue&type=template&id=4985db6f&scoped=true"
import script from "./addNewNumbers.vue?vue&type=script&lang=js"
export * from "./addNewNumbers.vue?vue&type=script&lang=js"
import style0 from "./addNewNumbers.vue?vue&type=style&index=0&id=4985db6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985db6f",
  null
  
)

export default component.exports